import { uniq } from 'lodash';
import { memo } from 'react';

import { TEditorConfig } from 'com/Editor/Editor/interface';
import { getKeys } from 'core/helpers/object';
import { FormGroup, FormInput, LangInput } from 'core/ui/Form';
import { ImageInput } from 'core/ui/ImageInput';

const WordEditorForm: TEditorConfig<TDeck, TWord, TWordUpdate>['Form'] = ({
  editingEntity: editingWord,
  container: deck,
  onChange,
}) => {
  const definitionsLangs: TLangAndNone[] = uniq([
    ...deck.definitionLangs,
    ...getKeys(editingWord.definitions),
  ]);

  return (
    <>
      <FormGroup title="Definition">
        {definitionsLangs.map((lang, idx) => (
          <LangInput
            placeholder={`Definition: ${lang}`}
            value={editingWord.definitions[lang] || ''}
            name={`definitions.${lang}`}
            key={lang}
            onChange={onChange}
            lang={lang}
            autoFocus={idx === 0}
          />
        ))}
        <FormInput
          placeholder="Note"
          name="note"
          value={editingWord.note || ''}
          onChange={onChange}
        />
        <ImageInput
          name="definitionResourceBinary"
          resourceUid={editingWord.definitionResourceUid}
          resourceBinary={editingWord.definitionResourceBinary}
          onChange={onChange}
        />
      </FormGroup>

      <FormGroup title="Value">
        {deck.lang ? (
          <LangInput
            placeholder="Value"
            name="value"
            value={editingWord.value}
            onChange={onChange}
            lang={deck.lang}
          />
        ) : (
          <FormInput
            placeholder="Value"
            name="value"
            value={editingWord.value}
            onChange={onChange}
          />
        )}

        <FormInput
          placeholder="Value note"
          name="valueNote"
          value={editingWord.valueNote || ''}
          onChange={onChange}
        />
        <ImageInput
          name="valueResourceBinary"
          resourceUid={editingWord.valueResourceUid}
          resourceBinary={editingWord.valueResourceBinary}
          onChange={onChange}
        />
      </FormGroup>
    </>
  );
};

export default memo(WordEditorForm);
